import { t } from 'i18next'
import React, { useState, useEffect } from 'react'
import { WithContext as ReactTags } from 'react-tag-input'
import { Tag } from 'react-tag-input/types/components/SingleTag'

interface TagProps {
  onTagDataChange: (newTagData: string[]) => void
  label: string
  classNameLabel?: string
  tags: string[]
}



const InputTag = ({
  onTagDataChange,
  label,
  classNameLabel,
  tags,
}: TagProps) => {
  const [localTags, setLocalTags] = useState<Tag[]>([])

useEffect(() => {
  setLocalTags(tags.map((tag) => ({ id: tag, text: tag, className: '' })))
}, [tags])

  const handleDelete = (i: number) => {
    const newTags = [...localTags]
    newTags.splice(i, 1)
    setLocalTags(newTags)
    onTagDataChange(newTags.map((tag) => tag.text))
  }

  const handleAddition = (tag: Tag) => {
    const newTags = [...localTags, tag]
    setLocalTags(newTags)
    onTagDataChange(newTags.map((tag) => tag.text))
  }

  return (
    <>
      <label className={`${classNameLabel} p-0`}>{label}</label>
      <ReactTags
        tags={localTags}
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        allowDragDrop={false}
        placeholder={`${t('ENTER_TAG')}`}
      />
    </>
  )
}

export default InputTag
